export enum MemoryHelpRevisionStatus {
    Denied = 'denied',
    Confirm = 'confirm',
    Allowed = 'allowed',
}